	import { CommonModule } from '@angular/common';
	import { NgModule } from '@angular/core';
	import { FormsModule, ReactiveFormsModule } from '@angular/forms';
	import { RouterModule, Routes } from '@angular/router';

	import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
	import { CardSnippetModule } from '../../../@core/components/card-snippet/card-snippet.module';
	import { CoreCommonModule } from '../../../@core/common.module';
	import { NgSelectModule } from '@ng-select/ng-select';
	import {ElementsModule} from '../../../app/main/elements/elements.module';
	import { ForgotPasswordComponent } from '../../../app/main/authentication/forgot-password/forgot-password.component';
	import { LoginComponent } from '../../../app/main/authentication/login/login.component';
	import { RegisterComponent } from '../../../app/main/authentication/register/register.component';
	import { ResetPasswordComponent } from '../../../app/main/authentication/reset-password/reset-password.component';
	import { DirectivesModule } from '../directives/directives.module';

	// routing
	const routes: Routes = [
		{
			path: 'login',
			component: LoginComponent
		},
		{
			path: 'register',
			component: RegisterComponent
		},
		{
			path: 'reset-password/:id',
			component: ResetPasswordComponent,
			data: { path: 'reset-password/:id' }
		},
		{
			path: 'reset-password/:id/:email',
			component: ResetPasswordComponent,
			data: { path: 'reset-password/:id/:email' }
		},
		{
			path: 'forgot-password',
			component: ForgotPasswordComponent
		}
	];

	@NgModule({
	declarations: [
		LoginComponent,
		RegisterComponent,
		ForgotPasswordComponent,
		ResetPasswordComponent,
	],
	imports: [CommonModule, RouterModule.forChild(routes), NgbModule, FormsModule, ReactiveFormsModule, CoreCommonModule,
				NgSelectModule, CardSnippetModule, ElementsModule,DirectivesModule],
	exports:[LoginComponent, RegisterComponent, ForgotPasswordComponent, ResetPasswordComponent, DirectivesModule],
	})
	export class AuthenticationModule {}